export default __webpack_public_path__ + "static/media/zambia.6b4f77b3.jpg";